import { BlockNoteEditor } from '@blocknote/core';
import { BlockSchema } from '../schema';

const getEditorDomSearchRoot = (editor: BlockNoteEditor<BlockSchema>) => {
  const domElement = editor.domElement;
  if (!domElement) {
    return null;
  }

  const root = domElement.closest('.bn-editor') ?? domElement;
  return root instanceof HTMLElement ? root : null;
};

export default getEditorDomSearchRoot;
